import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Icon } from '@/components/ui';
import { AccountsTab } from './lib/deriveRows';
import { CreateAccountSheet } from './CreateAccountSheet/CreateAccountSheet';

interface AccountsCreateFabProps {
  tab: AccountsTab;
}

/**
 * Mobile "create account" entry point. Gated by the same /api/me permissions as
 * the desktop "New company/project" button (see AccountsPage); the BE also
 * enforces this on POST /api/project. Opens the native mobile CreateAccountSheet
 * (the desktop AddCompany Bootstrap modal is unchanged and still used on desktop).
 */
export const AccountsCreateFab = ({ tab }: AccountsCreateFabProps) => {
  const [open, setOpen] = useState(false);
  const permissions = useSelector(
    (s: any) =>
      s.project?.permissions || {
        canCreateCompany: false,
        canCreateProject: false,
      }
  );

  const isCompanies = tab === 'companies';
  const canCreate = isCompanies
    ? permissions.canCreateCompany
    : permissions.canCreateProject;
  if (!canCreate) return null;

  const label = isCompanies ? 'New company' : 'New internal project';

  return (
    <>
      <button
        type="button"
        aria-label={label}
        title={label}
        onClick={() => setOpen(true)}
        className="tw-fixed tw-right-[20px] tw-z-20 tw-w-[56px] tw-h-[56px] tw-m-0 tw-p-0 tw-rounded-full tw-bg-ds-primary tw-text-white tw-border-0 tw-cursor-pointer tw-shadow-ds-e4 tw-inline-flex tw-items-center tw-justify-center"
        style={{
          bottom: 'calc(64px + 20px + env(safe-area-inset-bottom, 0px))',
        }}
      >
        <Icon name="plus" size={26} color="#fff" />
      </button>
      <CreateAccountSheet
        open={open}
        tab={tab}
        onClose={() => setOpen(false)}
      />
    </>
  );
};
